// eslint-disable-next-line import/no-anonymous-default-export
export default {
  loading: false,
  error: false,
  getSalesReportListStatus: { data: null },
  getServicesReportListStatus: { date: null },
  getCompanyReportListStatus: { date: null },
  getCompanyViewServiceListStatus: { data: null },
  getOutstandingReportListStatus: { data: null },
};
